export const CURRENT_PRODUCT_SETTINGS_VERSION = "3.0.0";
